import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  signal,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IconComponent } from '../icon/icon';
import type { IconName } from '../icon/icon';

export interface SidebarItem {
  label: string;
  link?: string;
  icon?: IconName;
  /** Éléments enfants (groupe repliable). */
  children?: SidebarItem[];
  /** Badge numérique optionnel. */
  count?: number;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-sidebar',
  imports: [RouterLink, RouterLinkActive, IconComponent],
  styleUrl: './sidebar.scss',
  templateUrl: './sidebar.html',
})
export class SidebarComponent {
  /** Éléments de navigation (groupes repliables supportés). */
  readonly items = input<SidebarItem[]>([]);

  /** Nom de la marque affiché en haut de la barre. */
  readonly brand = input('');

  /** Initiale / symbole affiché dans le logo (à côté du nom). */
  readonly brandIcon = input('');

  /** Replie la barre latérale en mode icônes seules. */
  readonly collapsed = input(false);

  /** Ouvre la barre en superposition (écrans mobiles). */
  readonly mobileOpen = input(false);

  /** Émis pour demander la fermeture (clics sur mobile). */
  readonly closeMobile = output<void>();

  /** Émis pour demander le basculement du mode replié. */
  readonly toggleCollapsed = output<void>();

  /** Groupes ouverts (index des groupes enfants). */
  protected readonly openGroups = signal<Set<number>>(new Set());

  protected readonly visibleLabel = computed(() => !this.collapsed());

  protected toggleGroup(index: number): void {
    this.openGroups.update((set) => {
      const next = new Set(set);
      if (next.has(index)) {
        next.delete(index);
      } else {
        next.add(index);
      }
      return next;
    });
  }

  protected isOpen(index: number): boolean {
    return this.openGroups().has(index);
  }

  protected onItemClick(): void {
    this.closeMobile.emit();
  }
}
